import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PublicRoute from './PublicRoutes';
import PrivateRoute from './PrivateRoutes';
// import NotFound from '../pages/NotFound';
import Login from '../pages/auth/Login';
import QrGeneration from '../pages/QrGeneration';
import QrHistory from '../pages/QrHistory';
import Redemption from '../pages/Redemption';
import KycModule from '../pages/Kyc';
import Tickets from '../pages/Tickets';
import RedemptionHistory from '../pages/RedemptionHistory';
import AddUser from '../pages/AddUser';
import ScanHistory from '../pages/ScanHistory';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<PublicRoute element={<Login />} />} />
            <Route path="/login" element={<PublicRoute element={<Login />} />} />
            <Route path="/qr-generation" element={<PrivateRoute element={<QrGeneration />} />} />
            <Route path="/qr-history" element={<PrivateRoute element={<QrHistory />} />} />
            <Route path="/redemption" element={<PrivateRoute element={<Redemption />} />} />
            <Route path="/kyc" element={<PrivateRoute element={<KycModule />} />} />
            <Route path="/add-user" element={<PrivateRoute element={<AddUser />} />} />
            <Route path="/ticket" element={<PrivateRoute element={<Tickets />} />} />
            <Route path="/redemption-history" element={<PrivateRoute element={<RedemptionHistory />} />} />
            <Route path="/scan-history" element={<PrivateRoute element={<ScanHistory />} />} />
            {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
    );
};

export default AppRoutes;